import { Context } from "@baseline/runtime";
import { ProviderOptions } from "../../config";
import { CardProvider } from "./card-provider";

export class CardService {
  constructor(readonly context: Context, options?: CardService.Options) {
    const {
      provider: { name: provider, options: providerOptions },
    } = options ?? { provider: {} };
    this.provider = CardProvider.create(provider, providerOptions);
  }
  initializeApiClients(apiOrigin: string, token: string): void {
    this.provider.initializeApiClients(apiOrigin, token);
  }

  paymentSetup(
    transactionId: string,
    encodedSessionData: string,
    componentRef: ComponentRef
  ): Promise<void> {
    return this.provider.paymentSetup(transactionId, encodedSessionData, componentRef);
  }

  tokenizationSetup(
    encodedSessionData: string,
    componentRef: ComponentRef
  ): Promise<void> {
    return this.provider.tokenizationSetup(encodedSessionData, componentRef);
  }

  async submitSession(): Promise<SessionsResult> {
    const sessionResult = await this.provider.submitSession();
    return sessionResult;
  }

  provider: CardProvider;
}

export namespace CardService {
  export interface Options {
    provider: ProviderOptions;
  }
}
